import CampaignWizard from './CampaignWizard.js';
import enhance from './enhancer';

export default enhance(CampaignWizard);
